import InviteFriend from 'views/inviteFriend/InviteFriend.container';

export default InviteFriend;